<template>
  <v-card class="mx-auto my-2" outlined>
    <v-list-item three-line>
      <v-list-item-content>
        <div class="headline mb-4">{{bug.identifier}}</div>
        <p class="bug-count mb-1">{{bug.error}}</p>
        <v-list-item-subtitle>{{bug.os}}, {{bug.browser}}, {{bug.website_version}}</v-list-item-subtitle>
        <v-list-item-subtitle>Created: {{bug.created}}</v-list-item-subtitle>
        <v-list-item-subtitle>User: {{bug.user.email}}</v-list-item-subtitle>
      </v-list-item-content>
      <v-list-item-avatar color="indigo" size="28">
        <span class="white--text bug-count">{{bug.count}}</span>
      </v-list-item-avatar>
    </v-list-item>
    <v-card-actions>
      <slot name="actions" />
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: 'BugCard',
  props: ['bug']
}
</script>

<style lang="css" scoped>
  .bug-count {
    font-size: 1.2rem !important;
    font-weight: 400;
    margin: auto;
    letter-spacing: normal !important;
    font-family: "Roboto", sans-serif !important;
  }
</style>
